// Library Imports
import React, { FC } from 'react';

// Local Imports
import ResetPasswordForm from '../../../components/ResetPassword';

const ResetPassword: FC = () => {
    return (
        <React.Fragment>
            <div className='h-screen flex items-center justify-center py-[20px] overflow-auto bg-gradient-to-r from-main-screen-secondary/20 to-main-screen-primary/60'>
                {/* Container */}
                <div className='flex w-[1600px] mx-auto h-full'>
                    {/* Register Form */}
                    <ResetPasswordForm />
                </div>
            </div>
        </React.Fragment>
    );
};

export default ResetPassword;
